import axios from "@/libs/phpAxios"
import Axios from "axios"

interface PhpRespone {
  code: number
  data: any
  msg: string
}

export const getUploadInfo = async (): Promise<PhpRespone> => {
  return (
    await axios.request({
      url: "merch/api/get-qiniu-token",
    })
  ).data
}

export const upLoadPhoto = async (formData: any) => {
  return Axios.request({
    headers: {
      "Content-Type": "multipart/form-data",
    },
    method: "POST",
    url: "https://up-na0.qiniup.com/",
    data: formData,
  })
}
